import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.link.js";
import { getImgFromStr, getDateTimeStamp, getDateDiff } from "../../unit/public";
import { extractLoginData, getAccount } from "../../unit/UserUtil";
import dsteem from "../../unit/DsteemUtil";
export default {
  props: ["communities"],
  components: {},
  name: "community-easy-card",
  data: function data() {
    return {
      ata: null,
      link: "",
      headImg: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var account;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.link = "/trending/" + _this.communities[0];
              _context.next = 3;
              return getAccount(_this.communities[0]);

            case 3:
              account = _context.sent;
              _this.headImg = account.profile_image;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};